import ArrowSquareUp from './ArrowSquareUp';

export default ArrowSquareUp;
